package components.project.configuration.additional

import components.project.freezableEditButton
import it.neckar.commons.kotlin.js.safeGet
import it.neckar.lizergy.model.configuration.components.ExistingPVFacilityConfiguration
import it.neckar.open.kotlin.lang.toCheckboxChar
import it.neckar.react.common.*
import it.neckar.react.common.form.*
import it.neckar.react.common.form.EditableStatus.*
import kotlinx.html.title
import plannerI18nConfiguration
import react.*
import react.dom.*

/**
 *
 */
fun RBuilder.existingPVFacilityPreview(
  existingPVFacilityConfiguration: ExistingPVFacilityConfiguration,
  editableStatus: EditableStatus,
  editAction: (additionalPosition: ExistingPVFacilityConfiguration) -> Unit,
  deleteAction: (additionalPosition: ExistingPVFacilityConfiguration) -> Unit,
): Unit = child(ExistingPVFacilityPreview) {
  attrs {
    this.existingPVFacilityConfiguration = existingPVFacilityConfiguration
    this.editableStatus = editableStatus
    this.editAction = editAction
    this.deleteAction = deleteAction
  }
}

val ExistingPVFacilityPreview: FC<ExistingPVFacilityPreviewProps> = fc("ExistingPVFacilityPreview") { props ->
  val existingPVFacilityConfiguration = props::existingPVFacilityConfiguration.safeGet()
  val editableStatus = props::editableStatus.safeGet()
  val editAction = props::editAction.safeGet()
  val deleteAction = props::deleteAction.safeGet()


  div {
    attrs {
      if (editableStatus == ReadOnly) {
        title = "Dieses Angebot kann nicht weiter bearbeitet werden!"
      }
    }

    h4("card-title mt-0 mb-3") {
      +"Bestandsanlage PV"

      freezableEditButton(editableStatus) {
        editAction(existingPVFacilityConfiguration)
      }

      if (editableStatus == Editable) {
        actionButtonWithConfirmationModal(
          icon = FontAwesomeIcons.Trash,
          modalTitle = "Soll die Bestandsanalge PV gelöscht werden?",
        ) { deleteAction(existingPVFacilityConfiguration) }
      }
    }

    p {
      +"Zählernummer: ${existingPVFacilityConfiguration.zaehlernummer}"
    }
    p {
      +"kWP Bestandsanlage: ${existingPVFacilityConfiguration.powerRating}"
    }
    p {
      +"Passwort Bestandsanlage: ${existingPVFacilityConfiguration.facilityPassword}"
    }
    existingPVFacilityConfiguration.existingInverters.let { existingInverters ->
      p {
        +"${existingInverters.size} Bestandwechselrichter: ${existingInverters.joinToString(", ") { it.format(plannerI18nConfiguration) }}"
      }
    }
    p {
      +"Einspeiseart: ${existingPVFacilityConfiguration.einspeiseart.format(plannerI18nConfiguration)}"
    }
    p {
      +"Einbindung in neue Anlage: ${existingPVFacilityConfiguration.integrateIntoFacility.toCheckboxChar()}"
    }

  }
}

external interface ExistingPVFacilityPreviewProps : Props {
  var existingPVFacilityConfiguration: ExistingPVFacilityConfiguration
  var editableStatus: EditableStatus
  var editAction: (additionalPosition: ExistingPVFacilityConfiguration) -> Unit
  var deleteAction: (additionalPosition: ExistingPVFacilityConfiguration) -> Unit
}
